// Parcel's entry point. It pulls in the Scala.js output, which sbt writes on
// `fastLinkJS`. Point this at `-opt` instead of `-fastopt` for a `fullLinkJS`
// production build.
import { TyrianApp } from './target/scala-3.7.2/track-builder-opt/main.js';

TyrianApp.launch('app');
